import { Container, Spinner, Center } from '@chakra-ui/react'
import { HeadingPages } from '../../../../components/HeadingPages'

export function Loading() {
  return (
    <div>
      <HeadingPages name={'CONTROLE DE PRODUÇÃO'} bgColor={'#378bbf'} />
      <Container maxW="container.xl" py={6} my={16}>
        <Center h="200px">
          <Spinner size="xl" color="#378bbf" />
        </Center>
      </Container>
    </div>
  )
}
